import { Product } from '@core/models/piramide/Product';
import { PromotionalBannerInterface } from '../interfaces/promotional-banner.interface';
import { environment } from '@environments/environment';
import { todayInRange } from '@core/utils/date.util';
import { IQueryImages } from '../services/bootstrap-query.service';
import { imagesByBreakpoint } from '@core/utils/breakpoints.util';

export class PromotionalBannerModel {
  private readonly _todayDate: Date = new Date();

  public readonly id: number = this._rawData.id;
  public readonly isMain: boolean = this._rawData.tipo == 1;
  public readonly title: string = this._rawData.titulo;
  public readonly description: string = this._rawData.descripcion;
  public readonly buttonViewProductsDesc: string = this._rawData.detalles?.find(
    (detail) => detail.tipo == 1,
  )?.descripcion;
  public readonly linkConditionsDesc: string = this._rawData.detalles?.find(
    (detail) => detail.tipo == 2,
  )?.descripcion;
  public readonly legalsDesc: string = this._rawData.detalles?.find((detail) => detail.tipo == 3)
    ?.descripcion;
  public readonly logoUrl: string = `${environment.apiImageStatic}/home_banner/${this._rawData.logo}`;
  public readonly images: IQueryImages = imagesByBreakpoint(
    this._rawData.imagenes.map((img) => ({
      ...img,
      imagen: `${environment.apiImageStatic}/home_banner/${img.imagen}`,
    })),
  );
  public readonly validFrom: Date | null =
    this._rawData.vigenciaInicio ? new Date(this._rawData.vigenciaInicio) : null;
  public readonly validUntil: Date | null =
    this._rawData.vigenciaFin ? new Date(this._rawData.vigenciaFin) : null;
  public readonly products: Product[];

  public get visible(): boolean {
    return todayInRange(
      this._todayDate,
      this.validFrom ?? this._todayDate,
      this.validUntil ?? this._todayDate,
    );
  }

  constructor(
    private _rawData: PromotionalBannerInterface,
    productsTotalIdx: Record<number, Product>,
  ) {
    this.products = this._rawData.productos.reduce((acc, idProduct) => {
      const product = productsTotalIdx[idProduct];
      if (product) acc.push(product);
      return acc;
    }, []);
  }
}
